<svelte:options runes={false} />

<script>
  export let summary;

  // Seven queue counters reading zero is not a dashboard, it is noise on the
  // first screen of an operator whose job is to send one page. Collapse to a
  // single line until something actually needs a person.
  $: counts = summary
    ? [
        { label: 'Payments awaiting confirmation', value: summary.webhookReceivedCount },
        { label: 'Retrying', value: summary.webhookRetryableCount },
        { label: 'Needs a look', value: summary.webhookNeedsReviewCount },
        { label: 'Still reconciling', value: summary.reconciliationBacklogCount },
        { label: 'Payments to review', value: summary.attemptReviewCount },
        { label: 'Refunds holding payouts', value: summary.blockingRefundCount },
        { label: 'Disputes holding payouts', value: summary.blockingDisputeCount },
      ]
    : [];
  $: outstanding = counts.filter((entry) => Number(entry.value) > 0);
</script>

{#if summary}
  <section class="operations-summary" class:needs-attention={outstanding.length > 0} aria-label="Payment operations">
    {#if outstanding.length === 0}
      <!-- Was "All payments settled normally." Nothing settles yet — S08–S10 are
           scaffolding — and none of the counters above measure settlement; they
           measure webhooks, reconciliation and review. The line now says what an
           empty queue actually means. -->
      <p class="operations-clear">Nothing needs your attention.</p>
    {:else}
      <h3>Payment operations</h3>
      <div class="operations-grid">
        {#each outstanding as entry (entry.label)}
          <span>{entry.label} <strong>{entry.value}</strong></span>
        {/each}
      </div>
      {#if summary.oldestOutstandingAt}
        <p class="quiet">Oldest outstanding: {summary.oldestOutstandingAt.toLocaleString()}</p>
      {/if}
    {/if}
  </section>
{/if}
